export const enum IncidenceType {
    OPERATIONAL = "1",
    CHARGE = "2",
}

